import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { SnackBar } from '../../../components/shared/Snackbar'
import { useRetrieveDocumentListQueryForSelectedAccounts } from '../../../store/rdot360Context/useRdot360DocumentsContext'
import LoaderContainer from '../DocumentFilter/LoaderContainer'
import {
  getSearchDateEnd,
  getSearchDateBegin,
  getIsDownloading,
  useDocumentModuleStore,
  getShowAllAccounts
} from '../DocumentFilter/store'
import TradeConfirmationTable from './TradeConfirmationTable'

const TradeConfirmationsTab = () => {
  const tab = 'Trade Confirmations'
  const selectedSearchDateEnd = useSelector(getSearchDateEnd(tab))
  const selectedSearchDateBegin = useSelector(getSearchDateBegin(tab))
  const showAllAccounts = useSelector(getShowAllAccounts())
  const isDownloading = useSelector(getIsDownloading)
  const { data, isLoading, isFetching, isUninitialized } =
    useRetrieveDocumentListQueryForSelectedAccounts(
      !!(selectedSearchDateBegin && selectedSearchDateEnd) && {
        VirtualTable: 'NF_TRADES',
        SearchDateComparison: 'R',
        SearchDateBegin: selectedSearchDateBegin,
        SearchDateEnd: selectedSearchDateEnd,
        SearchDateEndSpecified: true,
        SearchAllVersions: true,
        IncludeRelationships: false,
        RenditionFilter: '*',
        DateRange: ''
      },
      showAllAccounts
    )

  const { clearSelection } = useDocumentModuleStore()
  useEffect(() => {
    clearSelection()
  }, [data, clearSelection])

  return (
    <>
      <LoaderContainer
        isLoading={isLoading}
        isFetching={isFetching}
        isDownloading={isDownloading}
        dataListCount={data?.DocumentList?.length || 0}
      />
      <TradeConfirmationTable items={data?.DocumentList} />
      {!isUninitialized && !isFetching && data?.DocumentList?.length === 0 ? (
        <SnackBar type="Info" message="No Data Available" />
      ) : (
        ''
      )}
    </>
  )
}

export default TradeConfirmationsTab
